import { FC } from 'react';

import dynamic from 'next/dynamic';

import { useBreakpoint } from '@contexts/breakpoints';
import { BankInstallmentsViewModel } from '@api/index';
import { CloseIcon } from '@assets/icons';
import { Col, FlexibleDiv, Row } from '@components/formStyles';
import CustomIcon from '@components/utils/CustomIcon';
import { Currencies } from '@constants/constants';

import { OriginalPrice } from '../price';
import {
  CloseAction,
  CloseText,
  Header,
  InstallmentNumber,
  Overlay,
  ResponsiveCloseAction,
  ResponsiveHeader,
  TableCol,
  TableContainer,
  TableRow,
  Title,
  Total,
  Wrapper,
} from './styled';

const installment_numbers = [1, 3, 6, 9, 12, 18];

export interface BankInstallmentsProps {
  bankInstallments: BankInstallmentsViewModel[];
  onClose?: () => void;
}

const CustomIconDynamic = dynamic(() => import('@components/utils/CustomIcon'));

const BankInstallments: FC<BankInstallmentsProps> = ({
  bankInstallments,
  onClose,
}) => {
  const { xl } = useBreakpoint();
  return (
    <Overlay>
      {!xl ? (
        <ResponsiveHeader>
          <div />
          <Title>Taksit Seçenekleri</Title>
          <ResponsiveCloseAction data-testid='close-action' onClick={onClose}>
            <CustomIcon
              icon={CloseIcon}
              fontSize={24}
              width={24}
              height={24}
              paletteColor='black'
            />
          </ResponsiveCloseAction>
        </ResponsiveHeader>
      ) : null}
      <TableContainer>
        <Wrapper>
          {xl ? (
            <Header>
              <Title>Taksit Seçenekleri</Title>
              <CloseAction onClick={onClose}>
                <CloseText>Kapat</CloseText>
                <FlexibleDiv top={2}>
                  <CustomIconDynamic
                    icon={CloseIcon}
                    fontSize={24}
                    width={24}
                    height={24}
                    paletteColor='black'
                  />
                </FlexibleDiv>
              </CloseAction>
            </Header>
          ) : null}

          <TableRow>
            <InstallmentNumber />
            <InstallmentNumber>Peşin</InstallmentNumber>
            <InstallmentNumber>3 Taksit</InstallmentNumber>
            <InstallmentNumber>6 Taksit</InstallmentNumber>
            <InstallmentNumber>9 Taksit</InstallmentNumber>
            <InstallmentNumber>12 Taksit</InstallmentNumber>
            <InstallmentNumber>18 Taksit</InstallmentNumber>
          </TableRow>
          {bankInstallments.map((bank) => (
            <TableRow key={bank.bankName}>
              <TableCol>
                <img alt={bank.bankName} src={bank.imageUrl} />
              </TableCol>
              {installment_numbers.map((installmentNumber) =>
                bank.installments.some(
                  (installment) => installment.count === installmentNumber
                ) ? (
                  <TableCol>
                    <Col>
                      {installmentNumber !== 1 ? (
                        <>
                          <Row justifyContent='center'>
                            <OriginalPrice
                              noLine
                              currency={bank.currencyCode || Currencies.TL}
                              price={
                                bank.installments.find(
                                  (installment) =>
                                    installment.count === installmentNumber
                                )?.price
                              }
                            />

                            <FlexibleDiv left={3} right={3}>
                              x
                            </FlexibleDiv>
                            {installmentNumber}
                          </Row>
                          <Row justifyContent='center'>
                            <Total>Toplam:</Total>
                            <OriginalPrice
                              noLine
                              currency={bank.currencyCode || Currencies.TL}
                              price={
                                bank.installments.find(
                                  (installment) =>
                                    installment.count === installmentNumber
                                )?.totalPrice
                              }
                            />
                          </Row>
                        </>
                      ) : (
                        <OriginalPrice
                          noLine
                          currency={bank.currencyCode || Currencies.TL}
                          price={
                            bank.installments.find(
                              (installment) =>
                                installment.count === installmentNumber
                            )?.totalPrice
                          }
                        />
                      )}
                    </Col>
                  </TableCol>
                ) : (
                  <TableCol>
                    <span>-</span>
                  </TableCol>
                )
              )}
            </TableRow>
          ))}
        </Wrapper>
      </TableContainer>
    </Overlay>
  );
};

export default BankInstallments;
